
import * as noneRuntime$SMCzp4MfqF from '/home/g/p/vision/node_modules/.pnpm/@nuxt+image@1.9.0_db0@0.3.1_drizzle-orm@0.40.1_@cloudflare+workers-types@4.20250705.0_g_dd2cd24a664829fee8325f27ef0f36c9/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "png",
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$SMCzp4MfqF, defaults: {} }
}
        